import environmentVariables from "../enviromentVariables/index.js.erb"

export function isJobApp(){
  return window.location.hostname.includes(environmentVariables.job_post_app_host)
}

export function isOpenRemApp(){
  return window.location.hostname.includes(environmentVariables.open_rem_app_host)
}

export function isOpenDirectorApp(){
  return window.location.hostname.includes(environmentVariables.app_host)
}
